import React from 'react';
import PropTypes from 'prop-types';

const Loading = () => { 
    return (
        <img src={require('../../Images/ajax-loader.gif')} alt="Loading..."/>
    );
};

export default Loading;
